import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { CommissionChargeCancelMsg } from "../../../Common/AdviserCharges/Components/CommissionChargeCancelMsg";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { AdviceChargeReview } from "../../../Common/Review/Component/AdviceChargeReview";
import { BWACheck } from "../../../Common/Review/Component/BWACheck";
import { InvestmentReview } from "../../../Common/Review/Component/InvestmentReview";
import { PaymentsInReview } from "../../../Common/Review/Component/PaymentsInReview";
import { IWizardDataModelTemplate } from "../../../SinglePaymentTransferWizard/Models/WizardDataModelTemplate";
import { RegularPaymentActionType } from "../../Resource/Contents";

interface IReviewProps extends IProcessComponentProps {
    type: SubAccountType;
    data: IWizardDataModelTemplate;
    hasCashIsa?: boolean;
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private isShowInvestmentSelection(data, subAccountType): boolean {
        if (SubAccountTypeHelper.isOnPlatformPension(subAccountType))
            {return (
                data.PreRetirementInstrumentSelections?.Instruments?.length > 0 ||
                data.PostRetirementInstrumentSelections?.Instruments?.length > 0
            );}
        return data.InstrumentSelections?.Instruments?.length > 0;
    }

    private getReviewProps = (data, subAccountType, processType) => {
        return { data: data, subAccountType: subAccountType, process: processType, colNum: 3 };
    };

    public render(): JSX.Element {
        const processType =
            getQueryParameters()["action"] === RegularPaymentActionType.Edit
                ? ProcessType.EditRegular
                : ProcessType.AddRegular;
        const { data, type } = this.props;
        const contribution = data.Contribution;
        return (
            <div>
                <h2>Review</h2>
                <CommissionChargeCancelMsg
                    processType={processType}
                    cancelAll={this.props.data.Contribution.CancelAllCommissionCharges}
                />
                <BWACheck extraInfo={data} />
                <PaymentsInReview
                    isOpen={true}
                    {...this.getReviewProps(contribution, type, processType)}
                    extraInfo={data}
                />
                {!SubAccountTypeHelper.isCashAccount(type) && (
                    <AdviceChargeReview {...this.getReviewProps(contribution, type, processType)} extraInfo={data} />
                )}
                {this.isShowInvestmentSelection(contribution, type) && (
                    <InvestmentReview
                        {...this.getReviewProps(contribution, type, processType)}
                        extraInfo={data}
                        ownerHierarchyId={HierarchyIdHelper.generateHierarchyId(this.props.data.HierarchyId).entityId}
                    />
                )}
            </div>
        );
    }
}
